import { DOCUMENT, DestroyRef, Injectable, inject, signal } from '@angular/core';

/** Je li uređaj na mreži (`navigator.onLine` + događaji `online` / `offline`). */
@Injectable({ providedIn: 'root' })
export class MrezaService {
  private readonly _naMrezi = signal(true);
  readonly naMrezi = this._naMrezi.asReadonly();

  constructor() {
    const win = inject(DOCUMENT).defaultView;
    if (!win) {
      return;
    }
    // onLine === false je pouzdan znak da mreže nema; true samo znači da sučelje postoji.
    this._naMrezi.set(win.navigator.onLine !== false);
    const naMrezi = (): void => this._naMrezi.set(true);
    const bezMreze = (): void => this._naMrezi.set(false);
    win.addEventListener('online', naMrezi);
    win.addEventListener('offline', bezMreze);
    inject(DestroyRef).onDestroy(() => {
      win.removeEventListener('online', naMrezi);
      win.removeEventListener('offline', bezMreze);
    });
  }
}
